module.exports = __webpack_public_path__ + "static/media/fresh-factory-banner1.2804cb15.png";